/* jshint esversion: 8 */
define([
  "computeResource/collections/collection"
], function (
  Collection
) {

  class WebAppServerCollection extends Collection {

    constructor (args) {
      super(args);
    }

  }

  return WebAppServerCollection;
});
